import {
    isValidElement,
    Children,
    useMemo,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarMenuSubItemProps from "./type";
import stylesheet from "./stylesheet";
import {
    SidebarSubItemContext,
    useSidebarSubContext
} from "../../context";
import type {
    SidebarSubItemContextType
} from "../../type";
import SidebarMenuBadge from "../menuBadge";

const SidebarMenuSubItem: FC<ISidebarMenuSubItemProps> = ({
    children,
    style,
    ...props
}) => {
    useSidebarSubContext({
        part: "Sidebar.MenuSubItem"
    });

    const items = Children.toArray(children);

    const badgeElement = items.find((item) => isValidElement(item) && item.type === SidebarMenuBadge);

    const others = items.filter((item) => item !== badgeElement);

    const context = useMemo<SidebarSubItemContextType>(() => ({
        badge: badgeElement
    }), [
        badgeElement
    ]);

    return <SidebarSubItemContext.Provider
        value={context}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container
            ]}
            role="listitem"
        >
            {others}
        </View>
    </SidebarSubItemContext.Provider>;
};
export default SidebarMenuSubItem;
